<template>
  <div>
    <Spinner ref="spinner" :block="true"/>
    <div class="container">
    <div class="row seven-cols">
    <div class="col-md-1">
      <div class="card-counter pending">
        <span class="count-numbers">{{ counters.pending }}</span>
        <span class="count-name">Aguardando analise</span>
      </div>
    </div>
    <div class="col-md-1">
      <div class="card-counter typed">
        <span class="count-numbers"> {{ counters.pendingSellerAction }} </span>
        <span class="count-name">Aguardando lojista</span>
      </div>
    </div>
    <div class="col-md-1">
      <div class="card-counter warning">
        <span class="count-numbers"> {{ counters.incomplete }} </span>
        <span class="count-name">Incompleto</span>
      </div>
    </div>
    <div class="col-md-1">
      <div class="card-counter black">
        <span class="count-numbers"> {{ counters.blacklist }} </span>
        <span class="count-name">Blacklist</span>
      </div>
    </div>
    <div class="col-md-1">
      <div class="card-counter success">
        <span class="count-numbers"> {{ counters.validated }} </span>
        <span class="count-name">Validado</span>
      </div>
    </div>
    <div class="col-md-1">
      <div class="card-counter danger">
        <span class="count-numbers"> {{ counters.reproved }} </span>
        <span class="count-name">Reprovado</span>
      </div>
    </div>
    <div class="col-md-1">
      <div class="card-counter canceled">
        <span class="count-numbers"> {{ counters.inactive }} </span>
        <span class="count-name">Encerrado</span>
      </div>
    </div>
  </div>
</div>
    <div class="container-fluid" v-if="sellerList">
      <SellerListFilter v-model="filter" @input="emit" @submit="search"/>
      <div class="table-responsive">
        <table class="table">
          <thead>
            <th>Lojista</th>
            <th>Data do cadastro</th>
            <th>Aplicativo</th>
            <th>Situação</th>
            <th></th>
          </thead>
          <tbody>
            <tr v-for="seller in sellerList" :key="seller.id">
              <td>
                {{ seller.fullName }}<br>
                <small class="text-secondary">
                  {{ seller.taxDocument }}
                </small><br>
                <small class="text-secondary">
                  {{ seller.email }}
                </small>
              </td>
              <td>
                {{ seller.createdAt | datetime }}<br>
                <small class="text-secondary" v-if="seller.trialExpiration">
                    <span v-if="expirationDays(seller.trialExpiration) >= 0">
                    {{ expirationDays(seller.trialExpiration) }}
                    <span v-if="expirationDays(seller.trialExpiration) != 1">dias restantes</span>
                    <span v-if="expirationDays(seller.trialExpiration) == 1">dia restante</span>
                    </span>
                    <span v-if="expirationDays(seller.trialExpiration) < 0" class="text-danger">
                    Expirado a {{ expirationDays(seller.trialExpiration) * -1 }}
                    <span v-if="expirationDays(seller.trialExpiration) != -1">dias</span>
                    <span v-if="expirationDays(seller.trialExpiration) == -1">dia</span>
                    </span>
                </small>
              </td>
              <td>
                <span class="badge badge-pill mb-1" :class="(seller.originApplication === null) ? 'text-dark' : ((seller.isPartner) ? 'text-success' : 'text-primary')"> {{ (seller.originApplication != null) ? `${seller.originApplication}` : `Aplicação não encontrada` }} </span>
              </td>
              <td>
                 <span class="badge badge-pill mb-1" :class="statusColor(seller.situation)"> {{ situation(seller.situation) }} </span>
              </td>
              <td class="text-right">
                <router-link :to="{ name: 'sellers-detail', params: { id: seller.id } }" class="btn btn-outline-info btn-block">
                  <i class="icon-magnifier"></i> &nbsp;
                  Visualizar
                </router-link>
              </td>
            </tr>
            <tr v-if="countSellers === 0">
              <td colspan="5">
                Nenhum cadastro encontrado.
              </td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-center">
          <paginator :count="countSellers" :perPage="perPage" @exchange="turnPage" />
        </div>
      </div>
    </div>
  </div>
</template>

<style type="text/css">
  @media (min-width: 768px){
  .seven-cols .col-md-1,
  .seven-cols .col-sm-1,
  .seven-cols .col-lg-1  {
    width: 100%;
    *width: 100%;
  }
}
@media (min-width: 992px) {
  .seven-cols .col-md-1,
  .seven-cols .col-sm-1,
  .seven-cols .col-lg-1 {
    width: 14.285714285714285714285714285714%;
    *width: 14.285714285714285714285714285714%;
    max-width: 14.285714285714285714285714285714% !important;
flex:none !important;
  }
}
@media (min-width: 1200px) {
  .seven-cols .col-md-1,
  .seven-cols .col-sm-1,
  .seven-cols .col-lg-1 {
    width: 14.285714285714285714285714285714%;
    *width: 14.285714285714285714285714285714%;
    max-width: 14.285714285714285714285714285714% !important;
flex:none !important;
  }
}
</style>

<script>
import AccountApi from '@/services/AccountApi'
import SellerListFilter from './SellerListFilter'

export default {
  name: 'SellerList',
  data () {
    return {
      filter: {
        index: 0,
        length: 10,
        partnerId: null
      },
      sellerList: {},
      counters: {},
      perPage: 10,
      count: 0
    }
  },
  async mounted () {
    await this.search()
  },
  methods: {
    async search () {
      this.$refs.spinner.show('Pesquisando cadastros...')
      const api = new AccountApi()
      const result = await api.sellers.list(this.filter)
      this.sellerList = result.sellers
      if (Object.keys(this.counters).length === 0 && this.counters.constructor === Object) {
        this.counters = result
      }
      this.count = result.count
      this.$refs.spinner.hide()
    },
    async turnPage (numberPage) {
      const fim = numberPage * this.perPage
      const inicio = fim - this.perPage
      this.filter.index = inicio
      this.filter.length = this.perPage
      await this.search()
    },
    emit (value) {
      this.filter.fullName = value.fullName
      this.filter.email = value.email
      this.filter.taxDocument = value.taxDocument
      this.filter.situation = value.situation
      this.filter.length = this.perPage
      this.filter.partnerId = value.partnerId
    },
    expirationDays (trial) {
      return trial ? Math.ceil((+new Date(trial) - +new Date()) / 1000 / 60 / 60 / 24) : -1
    },
    situation (type) {
      switch (type) {
        case 'incomplete':
          return 'Incompleto'
        case 'pending':
          return 'Pendente de análise'
        case 'pendingSellerAction':
          return 'Pendente de ação'
        case 'blacklist':
          return 'Blacklist'
        case 'validated':
          return 'Validado'
        case 'reproved':
          return 'Reprovado'
        case 'inactive':
          return 'Encerrado'
        default:
          return 'Pendente de analise'
      }
    },
    statusColor (type) {
      return {
        'text-warning': (type === 'incomplete'),
        'text-primary': (type === 'pending'),
        'text-info': (type === 'pendingSellerAction'),
        'text-dark': (type === 'blacklist'),
        'text-danger': (type === 'reproved'),
        'text-success': (type === 'validated'),
        'text-canceled': (type === 'inactive')
      }
    }
  },
  components: {
    SellerListFilter
  },
  computed: {
    countSellers () {
      return this.count
    }
  }
}
</script>
